import { CmsMeta } from '../cmsMeta';
import { Link } from 'react-router-dom';

type PopularCategoryItemProps = {
	title: string;
	img: string;
	width?: number;
	height?: number;
	link: string;
};

export const CmsPopularCategoryItem = ({ title, link, img, width, height }: PopularCategoryItemProps): JSX.Element => {
	return (
		<div className="popular-category">
			<Link to={link}>
				<img src={img} alt={title} width={width} height={height} />
				<h3>{title}</h3>
			</Link>
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description: 'One tile in the popular categories row: an image, a caption and a link into the catalogue.',
	example: [
		'CmsPopularCategoryItem',
		{
			title: 'Kopierpapier',
			img: 'https://image-cdn.content.tctc.se/…jpeg',
			link: '/c/buro-papier/buropapiere/kopierpapier',
		},
	],
};
